"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBlock = void 0;
// See: <https://html.spec.whatwg.org/#the-css-user-agent-style-sheet-and-presentational-hints>
// From: https://www.npmjs.com/package/rehype-minify-whitespace
const blocks = [
    'address',
    'article',
    'aside',
    'blockquote',
    'body',
    'br',
    'caption',
    'center',
    'col',
    'colgroup',
    'dd',
    'dialog',
    'dir',
    'div',
    'dl',
    'dt',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'legend',
    'li',
    'li',
    'listing',
    'main',
    'menu',
    'nav',
    'ol',
    'optgroup',
    'option',
    'p',
    'plaintext',
    'pre',
    'section',
    'summary',
    'table',
    'tbody',
    'td',
    'td',
    'tfoot',
    'th',
    'th',
    'thead',
    'tr',
    'ul',
    'wbr',
    'xmp', // Flow content, legacy
];
const isBlock = (tagName) => {
    return blocks.includes(tagName);
};
exports.isBlock = isBlock;
